/* @ngInject */
function billingService (CONSTANTS, ConnectorWebService, AdminService, Utils, RequestDeduplicationService) {
  const service = {
    getPricingPackages,
    getPricingPackageById,
    getPlansByPricingPackage,
    getAllDeskfyFeatures,
    getPlanFeatures,
    getPlanAddons,
    getPlanById,
    getCompanyFeaturesAndAddons,
    sendInterestEmail
  }
  return service

  function getPricingPackages (query = {}) {
    const { legacy } = query
    let url = CONSTANTS.URL_V2_BILLING_PRICING_PACKAGES

    if (typeof legacy === 'boolean') {
      url = Utils.fnAddQueryToUrl(url, { legacy })
    }

    return ConnectorWebService.get(url)
  }

  function getPricingPackageById (pricingPackageId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_BILLING_PRICING_PACKAGES_ID, [pricingPackageId])
    return ConnectorWebService.get(url)
  }

  function getPlansByPricingPackage (pricingPackageId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_BILLING_PRICING_PACKAGES_ID_PLANS, [pricingPackageId])
    return ConnectorWebService.get(url)
  }

  function getPlanById (planId) {
    const getPlanByIdRequest = () => ConnectorWebService.get(Utils.fnReplaceStringParams(CONSTANTS.URL_V2_BILLING_PLANS_ID, [planId]))
    return RequestDeduplicationService.deduplicateRequest('BillingServiceGetPlanById', getPlanByIdRequest)
  }

  function getPlanFeatures (planId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_BILLING_PLANS_ID_FEATURES, [planId])
    const getPlanFeaturesRequest = () => ConnectorWebService.get(url)
    return RequestDeduplicationService.deduplicateRequest('BillingServiceGetPlanFeatures', getPlanFeaturesRequest)
  }

  function getPlanAddons (planId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_BILLING_PLANS_ID_ADDONS, [planId])
    const getPlanAddonsRequest = () => ConnectorWebService.get(url)
    return RequestDeduplicationService.deduplicateRequest('BillingServiceGetPlanAddons', getPlanAddonsRequest)
  }

  function getAllDeskfyFeatures () {
    return ConnectorWebService.get(CONSTANTS.URL_V2_BILLING_FEATURES)
  }

  function sendInterestEmail (payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_COMPANIES_PLAN_INTEREST_EMAIL)
    return ConnectorWebService.post(url, payload)
  }

  function getCompanyFeaturesAndAddons (planId, billingPackageId) {
    return getPlanById(planId)
      .then((plan) => {
        return Promise.all([getPlanFeatures(planId), AdminService.getCompanyBillingPackageAddons(billingPackageId)])
          .then(([planFeatures, companyAddons]) => {
            return {
              ...plan,
              features: planFeatures.rows,
              addons: companyAddons.rows
            }
          })
      })
      .then((planWithFeatures) => {
        const mappedFeatures = _mapPlanFeatures(planWithFeatures.features)
        const mappedAddons = _mapPlanFeatures(planWithFeatures.addons)

        return {
          ...planWithFeatures,
          features: mappedFeatures,
          addons: mappedAddons
        }
      })
  }

  function _mapPlanFeatures (features) {
    return features.reduce((obj, feature) => {
      if (obj[feature.slug]) {
        return obj
      }

      obj[feature.slug] = {
        ...feature
      }

      return obj
    }, {})
  }
}

export { billingService }
